import { Button, Grid, SvgIcon, Typography } from '@mui/material';
import { useContext } from 'react';
import { Plus  } from '../../../assets';
import PageTitle from '../../../components/shared/PageTitle';
import { TrainingMaterialContext, TrainingMaterialValues } from '../contexts/TrainingMaterialContext';

const TrainingMaterialsTop=() => {
  const { t, openModal, hasWritePermission } = useContext(TrainingMaterialContext) as TrainingMaterialValues;
  
  return (
    <Grid container
      alignItems="center"
      spacing={2}>
      <Grid item
        xs={12}
        sx={{ display:'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'space-between' }}>
        <Grid item
          sx={{ marginRight: '20px' }}>
          <PageTitle>{t('title')}</PageTitle>
        </Grid>
       
        
      </Grid>
      <Grid item
        xs={6}>
        <Typography variant='textSM'>{t('info')}</Typography>
      </Grid>

      <Grid item
        xs={6}
        sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        {hasWritePermission && (
          <Button size='lg'
            startIcon={<SvgIcon><Plus /></SvgIcon>}
            onClick={openModal} >{t('createNewButton')} </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default TrainingMaterialsTop;